import { render, staticRenderFns } from "./SerachInfos.vue?vue&type=template&id=82cfa584&scoped=true"
import script from "./SerachInfos.vue?vue&type=script&lang=js"
export * from "./SerachInfos.vue?vue&type=script&lang=js"
import style0 from "./SerachInfos.vue?vue&type=style&index=0&id=82cfa584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cfa584",
  null
  
)

export default component.exports